import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './reducers/reducers';
import { getEnv } from '@/lib/env';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';

const bindMiddleware = middleware => {
  if (process.env.NODE_ENV !== 'production') {
    // ESM-only package: must be a static import (require() fails under webpack); only used in dev
    return composeWithDevToolsDevelopmentOnly(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

export const initStore = (initialState = {}) => {
  let middleware = [thunk];
  if (getEnv('NEXT_PUBLIC_ENABLE_CONSOLE_LOGS') === 'true') {
    middleware = [...middleware, logger];
  }
  return createStore(rootReducer, initialState, bindMiddleware(middleware));
};
